import { Div, HorizontalLayout, PaperLayout } from '@nic/ui-comps'
import { camelToDash, Suspense, useTranslation } from '@nic/commons'

import React, { useContext } from 'react'
import { Redirect } from 'react-router'
import { Divider, Space } from 'antd'
import { RequestContext } from '../Contexts/RequestContext'
import { RequestDetail } from '../DataDisplay/RequestDetail/RequestDetail'
import { Reload } from '../Navigation/NextReloadPrevButtons/NextReloadPrevButtons'
import { AxiosError } from 'axios'
import { printAxiosFetchError } from '../ErrorAlert/ErrorAlert'
import { AssignmentRequestContent } from './AssignmentRequestContent'

/**
 * Box contenente le informazioni e i controlli della Richiesta:
 * - Dettagli Richiesta
 * - Navigatore (Prev - Reload - Next) Richiesta
 * - Note Richiesta
 * @constructor
 */
export function RequestBox(props: { onReload: () => void }) {
  const request = useContext(RequestContext)
  const { scope } = useContext(RequestContext)
  const t = useTranslation()

  const handleOnReload = () => {
    props.onReload()
    request.reload && request.reload()
  }

  /**
   * Condizione per poter visualizzare le note:
   * che sia un operatore Registry e che le note esistano
   **/
  const hasNote = (note?: string): boolean => {
    return !!(note && scope === 'registry')
  }
  const handleError = (e: AxiosError) => {
    switch (e.response?.status) {
      case 404:
        return <Redirect to={'/404'} />
      case 403:
        return <Redirect to={'/403'} />
      default:
        return <>{printAxiosFetchError(e)}</>
    }
  }
  return (
    <Div
      width={'100%'}
      className={camelToDash(RequestBox.name)}
      data-cy={'request-box'}
      style={{ minWidth: '600px' }}
    >
      <Suspense
        renderError={handleError}
        state={request.stateReqById}
        render={(data) => (
          <>
            {/* Request box content*/}
            <PaperLayout asCard={true} width={'100%'}>
              <HorizontalLayout
                style={{
                  gap: 20,
                  justifyContent: 'space-between',
                  width: '100%',
                }}
              >
                <RequestDetail data={data} scope={request.scope} />
                <Space>
                  <Reload onReload={handleOnReload} type={'primary'} label={t('Reload')} />
                </Space>
              </HorizontalLayout>
              <Divider />
              <AssignmentRequestContent labels />
            </PaperLayout>
            {/* NOTE*/}
            {hasNote(data.note) && (
              <PaperLayout
                asCard
                style={{
                  backgroundColor: '#fffbe6',
                  borderLeft: '4px solid #faad14',
                  color: '#5f4b10',
                  boxShadow: '0 2px 8px rgba(95, 75, 16, 0.12)',
                  margin: '12px 0',
                  padding: '12px 16px',
                }}
              >
                <b>{t('Note')}:</b> {data.note}
              </PaperLayout>
            )}
          </>
        )}
      />
    </Div>
  )
}
